import { useTranslation } from "react-i18next";
import type { FieldError, UseFormMethods } from "react-hook-form";
import { alphaNumericWithoutSpaceRegex } from "@utils/regex";
import { LabeledTextField } from "@common/LabeledTextField/LabeledTextField";
import { cls } from "itsf-ui-common";
import { Typography } from "@mui/material";
import { useStyle } from "./style";

interface IParams {
    register: UseFormMethods["register"];
    error: FieldError | undefined;
    namePrefix?: string;
    defaultValue?: string;
    onChange?(): void;
}

export const AccountNumber = (props: IParams) => {
    const { error, register, namePrefix, defaultValue, onChange } = props;
    const { t } = useTranslation(["cart", "validation"]);
    const { classes } = useStyle();
    const fieldName = namePrefix ? `${namePrefix}accountNumber` : "accountNumber";

    return (
        <>
            <LabeledTextField
                className={cls("xtest_current_account_number_input", classes.accountTextField)}
                defaultValue={defaultValue}
                error={Boolean(error)}
                fullWidth
                helperText={error?.message}
                id="current-account-number"
                inputRef={register({
                    required: t("validation:required"),
                    maxLength: { value: 24, message: t("validation:tooManyCharacters", { count: 24 }) },
                    pattern: { value: alphaNumericWithoutSpaceRegex, message: t("validation:onlyLettersNumbers") },
                })}
                isRequired
                labelText={t("cart:accountNumber")}
                name={fieldName}
                onChange={() => {
                    if (onChange) {
                        onChange();
                    }
                }}
            />
            <Typography color="secondary" variant="small">
                {t("cart:accountNumberHelper")}
            </Typography>
        </>
    );
};
